export const OMS_COLUMNS = {
  name: {
    key: 'name',
    label: 'Name',
    isSortable: false,
  },
  phone: {
    key: 'phone',
    label: 'Phone Number',
    isSortable: false,
  },
  currentShift: {
    key: 'currentShift',
    label: 'Current Shift Till',
    isSortable: false,
  },
  nextShift: {
    key: 'nextShift',
    label: 'Next On Call/Duty Shift',
    isSortable: false,
  },
  reservationCondition: {
    key: 'reservationCondition',
    label: 'Reservation Condition',
    isSortable: false,
  },
  action: {
    key: 'action',
    label: '',
    isSortable: false,
  },
};

export const getOMSColumns = () => [
  OMS_COLUMNS.name,
  OMS_COLUMNS.phone,
  OMS_COLUMNS.currentShift,
  OMS_COLUMNS.nextShift,
  OMS_COLUMNS.reservationCondition,
  OMS_COLUMNS.action,
];
